import React from 'react';
export class componentUtility {
  static findByType(children: any, component: any): JSX.Element {
    const result: any = [];
    const type = component.displayName || component.name;
    React.Children.forEach(children, (child) => {
      const childType =
        child && child.type && (child.type.displayName || child.type.name);
      if (type.includes(childType)) {
        result.push(child);
      }
    });
    return result[0];
  }

  static createNewComponent<T>(
    name: string,
    constructor: Function,
    render: Function,
  ) {
    let newComponent = function (
      this: any,
      props: React.PropsWithChildren<T>,
    ): React.ReactElement {
      this.state = null;
      this.displayName = name;
      constructor.call(this, props);
      //return this because react calls the function with the new keyword, not returning this means typescript will complain that the component isn't a valid jsx element etc.
      return this;
    };

    newComponent.prototype.render = function () {
      return render();
    };

    Object.setPrototypeOf(newComponent.prototype, React.Component.prototype);
    return newComponent;
  }
}

export default componentUtility;
